<app-modal #modal [(display)]="modalService.displayed" [contentComponent]="modalService.contentComponent"
  [className]="modalService.className" (contentComponentBuilded)="modalService.setBuildedDialogComponent($event)"
  (close)="modalService.close()" />

<app-toaster />
@if (navigationControlsNavBar) {
<app-navbar />
}
<main class="router-outlet-container">
  <router-outlet></router-outlet>
</main>

@if (cookieControls) {
<app-cookie />
}


<div class="fake-zendesk">
  @if(fakeZendeskMenu) {
  <div class="fake-zendesk-content" [class.closing]="fakeZendeskMenuClosing">
    <h6>{{'fake_zendesk_bot.title' |  translate}}</h6>
    <p [innerHTML]="'fake_zendesk_bot.content' | translate: {link: supportSafeLink}"></p>
  </div>
  }
  <button (click)="toggleFakeZendeskMenu()"><kin-icon name="comment_fill" size="36" /></button>
</div>


<app-footer />